// extracted by mini-css-extract-plugin
module.exports = {"font_size_custom":"AddOperation_font_size_custom__2H50m"};